import { NavigateFunction, NavigateOptions, useNavigate } from 'react-router-dom';

const onNavigate = (navigate: NavigateFunction, path: string, options?: NavigateOptions) => navigate('../' + path, options);

export const useRouteHook = () => {
  const navigate = useNavigate();

  return {
    navigate: (path: string, options?: NavigateOptions) => onNavigate(navigate, path, options),
    back: () => navigate(-1),
  };
};
